import { AlertCircle, GitCommit, Upload } from "lucide-react";
import type { SessionIndicators as SessionIndicatorsType } from "@shared-core/data/feature-session-types";

interface SessionIndicatorsProps {
  indicators: SessionIndicatorsType | null;
  loading: boolean;
}

export function SessionIndicators({
  indicators,
  loading,
}: SessionIndicatorsProps) {
  if (!indicators && !loading) return null;

  return (
    <div className="flex items-center gap-4 px-3 py-1.5 border-b border-border bg-muted/20 text-xs">
      {loading && !indicators && (
        <span className="text-muted-foreground">Loading indicators...</span>
      )}

      {indicators?.unsaved_changes_present && (
        <span className="flex items-center gap-1 text-yellow-600">
          <AlertCircle className="size-3" />
          Unsaved changes
        </span>
      )}

      {indicators?.unpushed_commits_present && (
        <span className="flex items-center gap-1 text-blue-600">
          <Upload className="size-3" />
          Unpushed commits
        </span>
      )}

      {indicators?.loaded_commit_sha && (
        <span className="flex items-center gap-1 text-muted-foreground">
          <GitCommit className="size-3" />
          {indicators.loaded_commit_sha.slice(0, 7)}
        </span>
      )}
    </div>
  );
}
